export const DOG_SALON_SNAPS_PRODUCT = {
  /** 正式名（JA） */
  productNameJa: "ドッグサロン・スナップス",
  /** 正式名（EN） — 商標・対外表記の基準 */
  productNameEn: "Dog Salon Snaps",
  /** 略称（JA/EN 共通）— EN8CL と同じ型 */
  shortJa: "DSS",
  shortEn: "DSS",
  taglineJa: "予約・記録・料金・撮影・運営台帳まで。確定申告の下準備も端末内。犬は加工しない。",
  taglineEn: "Booking, cut notes, fees, snaps, and a local ops ledger for tax prep. Never edit the dog.",
  appIconPath: "/icons/icon-192.png",
  /** 表紙ヒーロー（1024 原本を円形表示） */
  coverHeroPath: "/brand/app-icon.jpg",
  /** @deprecated low-res banner; prefer coverHeroPath + CSS type */
  coverImagePath: "/brand/dss-cover.png",
  /** 改修依頼の宛名表示（任意送信時のみ）。業務データの閲覧者ではない */
  developerNameJa: "ココ",
  /**
   * 任意の改修依頼メール宛先。
   * 個人アドレスはリポジトリに書かず、`.env.local` の
   * `NEXT_PUBLIC_DSS_COCO_EMAIL` で設定する。
   * 未設定でも業務データは端末内のまま（運営者は閲覧できない）。
   */
  ownerDeskEmail:
    typeof process !== "undefined"
      ? (process.env.NEXT_PUBLIC_DSS_COCO_EMAIL ?? "").trim()
      : "",
} as const;

/**
 * オーナー向け方針（契約書風・箇条書き）。
 * 窓口フォーム本体には置かず、Q&A／使用方法に掲載する。
 */
export const OWNER_POLICY_ARTICLES_JA = [
  {
    article: "第1条",
    title: "閲覧権限",
    items: [
      "業務データを閲覧できるのは、オーナー（利用者）に限る。",
      "対象例：わんこの写真、飼い主情報、予約、カット記録、料金。",
      "開発者・EN8 Company・ココは、業務データを閲覧しない。",
    ],
  },
  {
    article: "第2条",
    title: "保管場所",
    items: [
      "データはオーナー端末のブラウザ内（IndexedDB）に留まる。",
      "運営側クラウドへ自動で上げて覗く仕組みはない。",
      "端末を替えた場合、その端末のデータは別扱いとする。",
    ],
  },
  {
    article: "第3条",
    title: "裏口の禁止",
    items: [
      "引き渡し後、運営側から中身を覗く裏口はない。",
      "個人情報保護のため、運営側からサロン業務データを取りに行かない。",
    ],
  },
  {
    article: "第4条",
    title: "改修メモと任意送信",
    items: [
      "気づきは、まず端末内の改修メモに残せる（非公開）。",
      "外へ出すのは、オーナーが「共有／送る」を行ったときのみ。",
      "相手に届くのは、送った文面と添付だけとする。",
    ],
  },
  {
    article: "第5条",
    title: "既存システム連携",
    items: [
      "既存の予約／会計ソフトがある場合、連携を検討できる。",
      "窓口でソフト名を任意送信してほしい。",
      "有料の連携・カスタム時は、本アプリを EN8CL から切り離し、ソースとデータをオーナー手元で改修できる形を前提とする。",
    ],
  },
] as const;

/** @deprecated use DOG_SALON_SNAPS_PRODUCT */
export const SALON_SNAP_PRODUCT = DOG_SALON_SNAPS_PRODUCT;

/** @deprecated prefer OWNER_POLICY_ARTICLES_JA */
export const OWNER_PRODUCT_POLICY_JA = {
  privacyOwnerOnly: OWNER_POLICY_ARTICLES_JA[0].items.join(" "),
  privacyNoBackdoor: OWNER_POLICY_ARTICLES_JA[2].items.join(" "),
  improveTogether: OWNER_POLICY_ARTICLES_JA[3].items.join(" "),
  integration: OWNER_POLICY_ARTICLES_JA[4].items.slice(0, 2).join(" "),
  detachWhenPaid: OWNER_POLICY_ARTICLES_JA[4].items[2],
} as const;
